const Y_OFFSET = 30;
const Y_OFFSET_SMALL = 20;
const X_OFFSET = 30;
const DURATION_DEFAULT = 0.6;
const DURATION_FAST = 0.5;
const DURATION_FASTER = 0.3;
const VIEWPORT_MARGIN_DEFAULT = "-80px";
const VIEWPORT_MARGIN_CLOSE = "-60px";

export const fadeInUp = {
  initial: { opacity: 0, y: Y_OFFSET },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: VIEWPORT_MARGIN_DEFAULT },
  transition: { duration: DURATION_DEFAULT },
};

export const fadeInUpSmall = {
  initial: { opacity: 0, y: Y_OFFSET_SMALL },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: VIEWPORT_MARGIN_CLOSE },
  transition: { duration: DURATION_DEFAULT },
};

export const fadeIn = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true },
  transition: { duration: DURATION_DEFAULT },
};

export const heroEntrance = (delay) => ({
  initial: { opacity: 0, y: delay > 0.5 ? Y_OFFSET_SMALL : Y_OFFSET },
  animate: { opacity: 1, y: 0 },
  transition: { duration: delay > 0.7 ? 0.8 : DURATION_DEFAULT, delay },
});

export const cardStagger = (index) => ({
  initial: { opacity: 0, y: Y_OFFSET },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: VIEWPORT_MARGIN_CLOSE },
  transition: { duration: DURATION_FAST, delay: index * 0.1 },
});

export const slideIn = {
  initial: { opacity: 0, x: X_OFFSET },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -X_OFFSET },
  transition: { duration: DURATION_FASTER },
};

export const thankYouEntrance = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5 },
};

export const thankYouDelayed = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, delay: 0.2 },
};

export const fadeInDelay02 = {
  ...fadeIn,
  transition: { duration: 0.6, delay: 0.2 },
};

export const fadeInDelay03 = {
  ...fadeIn,
  transition: { duration: 0.6, delay: 0.3 },
};

export const fadeInUpDelay015 = {
  ...fadeInUpSmall,
  transition: { duration: 0.6, delay: 0.15 },
};

export const fadeInUpDelay03 = {
  ...fadeInUpSmall,
  transition: { duration: 0.6, delay: 0.3 },
};
